<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('companies.add_certificate_verbose')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('companies.add_certificate_verbose')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">

              <accessible-el-select
                prop="certificate"
                v-model="form.certificate"
                :options="certificates.map(x => ({ id: x.idTemp, value: x.idTemp, name: x.CommonName }))"
                id-prefix="linkcertificatedialog"
                :isDisabled="isLoadingSelect"
              >
                <template #label>
                  {{$t('companies.certificate')}}
                </template>
              </accessible-el-select>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
            class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>
<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getCertificates } from '@/services/certificates/getCertificates'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'link-certificates-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: [Number, String],
      default: -1
    }
  },
  watch: {
    clientId: function (value, oldValue) {
      if (value && value > 0) {
        this.getCertificatesQuery()
      }
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        certificate: []
      },
      certificates: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
  },
  computed: {
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    getCertificatesQuery: async function () {
      this.isLoadedData = false
      const data = await getCertificates({ idCliente: this.clientId })
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        let cont = 0
        data.datosCertificados.forEach(element => {
          cont++
          element.idTemp = cont
        })
        this.certificates = data.datosCertificados
      }
      this.isLoadedData = true
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.certificate = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      const selected = this.certificates.filter(x => x.idTemp === this.form.certificate)[0]
      this.$emit('applyDialog', selected)
      this.form.certificate = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
